import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";

@Injectable()
export class NavBarService {

  // Observable string sources
  private navBarChangedSource = new Subject<boolean>();

  navBarChange$ = this.navBarChangedSource.asObservable();

  constructor() {
  }

  changeBackground(active: boolean) {
    this.navBarChangedSource.next(active);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/communication/nav-bar.service.ts